import { render, staticRenderFns } from "./Movers.vue?vue&type=template&id=5bd94113&scoped=true&"
import script from "./Movers.js?vue&type=script&lang=js&"
export * from "./Movers.js?vue&type=script&lang=js&"
import style0 from "./Movers.vue?vue&type=style&index=0&id=5bd94113&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd94113",
  null
  
)

export default component.exports